<!-- separation.component.html -->
<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="SeparationPolicyForm" (ngSubmit)="Validate(SeparationPolicyForm)"
        #SeparationPolicyForm="ngForm" novalidate>
        <div class="card-header">
            Separation Policy
        </div>
        <div class="card-body">
            <div class="d-flex align-items-center justify-content-start">
                <label class="me-2 mb-0 text-label-dark">
                    Policy Name:
                </label>
                <div class="col-md-4">
                    <input name="PolicyName" type="text" class="form-control" placeholder="Policy Name"
                        [(ngModel)]="PolicyName" required>
                </div>
            </div>

            <!-- <div class="d-flex align-items-center justify-content-start mt-4">
            <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                Allow employee to suggest last working day:
            </label>

            <input type="checkbox" class="form-check-input" id="lastWorkingDay">
        </div> -->

            <div class="d-flex align-items-center justify-content-start">
                <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                    Allow backdate separation <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                        [ngbTooltip]="tooltip.SeparationPolicy.AllowBackdateSeparation"></i> :
                </label>

                <input name="allowBackdateSeparation" type="checkbox" class="form-check-input" id="lastWorkingDay"
                    [(ngModel)]="allowBackdateSeparation">
                <div class="col-md-3 mt-4 ms-4">
                    <div class="input-group mb-3">
                        <input type="text" [disabled]="!allowBackdateSeparation" maxlength="3" pattern="^[0-9.]*$"
                            (keypress)="common.NumberOnly($event)" class="form-control form-control2 text-label-light"
                            placeholder="Ex. 01" [(ngModel)]="BackDateSeparationDays"
                            id="MinimumDaysForLeaveEligibility" name="MinimumDaysForLeaveEligibility" required>
                        <span class="input-group-text form-label" id="basic-MinimumDaysForLeaveEligibility">Back
                            Days</span>
                        <div class="invalid-feedback">
                            Please enter maximum days 365!
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-start" style="margin-top: -20px;">
                <label for="lastWorkingDayEditable" class="me-2 mb-0 text-label-dark">
                    Employee Last Working Day Editable <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                        [ngbTooltip]="tooltip.SeparationPolicy.LastWorkingDayEditable"></i> :
                </label>

                <input name="lastWorkingDayEditable" type="checkbox" class="form-check-input"
                    id="lastWorkingDayEditable" [(ngModel)]="lastWorkingDayEditable">

                <div class="col-md-3 mt-4 ms-4">
                    <div class="input-group mb-3">
                        <input type="text" maxlength="3" pattern="^[0-9.]*$" (keypress)="common.NumberOnly($event)"
                            [(ngModel)]="PastLWDLimitDays" class="form-control form-control2 text-label-light"
                            placeholder="Ex. 01" id="PastDaysLimit" name="PastDaysLimit"
                            [disabled]="!lastWorkingDayEditable" required>
                        <span class="input-group-text form-label" id="basic-PastDaysLimit">Past Days</span>
                        <div class="invalid-feedback">
                            Please enter maximum days 365!
                        </div>
                    </div>
                </div>

                <div class="col-md-3 mt-4 ms-4">
                    <div class="input-group mb-3">
                        <input type="text" maxlength="3" pattern="^[0-9.]*$" (keypress)="common.NumberOnly($event)"
                            [(ngModel)]="FutureLWDLimitDays" class="form-control form-control2 text-label-light"
                            placeholder="Ex. 01" id="FutureDaysLimit" name="FutureDaysLimit"
                            [disabled]="!lastWorkingDayEditable" required>
                        <span class="input-group-text form-label" id="basic-FutureDaysLimit">Future Days</span>
                        <div class="invalid-feedback">
                            Please enter maximum days 365!
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-auto align-self-center mt-1">
                    <label for="LeaveType" class="form-label text-label-dark">Leave Type :</label>
                </div>
                <div class="col-md-5 mt-2">
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='Month' name="policybased"
                                [(ngModel)]="policybasedon" [ngModelOptions]="{standalone: true}">
                            Months
                        </label>
                        <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='Day' name="policybased"
                                [(ngModel)]="policybasedon" [ngModelOptions]="{standalone: true}">
                            Days
                        </label>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-auto mt-2">
                    <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                        Probation:
                    </label>
                </div>
                <div class="col-md-2">
                    <input maxlength="3" pattern="^[0-9.]*$" (keypress)="common.NumberOnly($event)"
                        name="ProbationNoticePeriod" type="text" class="form-control" placeholder="Ex. 01"
                        [(ngModel)]="ProbationNoticePeriod" required>
                </div>
            </div>

            <div class="row">
                <div class="col-auto mt-2">
                    <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                        Confirmation:
                    </label>
                </div>
                <div class="col-md-2">
                    <input maxlength="3" pattern="^[0-9.]*$" (keypress)="common.NumberOnly($event)"
                        name="ConfirmedNoticePeriod" type="text" class="form-control" placeholder="Ex. 01"
                        [(ngModel)]="ConfirmedNoticePeriod" required>
                </div>
            </div>

            <div class="row mb-3 mt-4">
                <div class="col-md-auto">
                    <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                </div>
                <div class="col-md-5">
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel
                            *ngIf="(this.SeparationRuleID == 0) || (this.SeparationRuleID > 0 && common.ToLowerCase(SeparationRuleDetail.EmpType) == 'front')">
                            <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                [(ngModel)]="SeparationRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                [disabled]="SeparationRuleID > 0" (change)="GetApplicability()" required>
                            Front Office
                        </label>
                        <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel
                            *ngIf="(SeparationRuleID == 0) || (SeparationRuleID > 0 && common.ToLowerCase(SeparationRuleDetail.EmpType) == 'back')">
                            <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                [(ngModel)]="SeparationRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                [disabled]="SeparationRuleID > 0" (change)="GetApplicability()" required>
                            Back Office
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-auto align-self-center me-2">
                    <label for="DefaultRegularization" class="form-label text-label-dark">Default Policy
                        :</label>
                </div>
                <div class="col-md-5">
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=true name="DefaultRegularization"
                                [(ngModel)]="DefaultRule" [ngModelOptions]="{standalone: true}">
                            Yes
                        </label>
                        <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=false name="DefaultRegularization"
                                [(ngModel)]="DefaultRule" [ngModelOptions]="{standalone: true}">
                            No
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <div class="card m-1 mx-2">
            <div class="card-header">
                <div class="row">
                    <div class="col">Applicability</div>
                    <div class="col-md-3">
                        <div class="input-group">
                            <div class="input-group-text"><i class="bi bi-search"></i></div>
                            <input type="text" class="form-control" placeholder="Search Here.."
                                (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                        </div>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                            (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Filter':'Loading...'}}</button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2">
                        <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                            @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                            let i = $index) {
                            <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                <input class="form-check-input" type="radio"
                                    [value]=Applicability.WebESSApplicabilityMasterID name='WebESSApplicabilityMasterID'
                                    [(ngModel)]="SeparationRuleDetail.WebESSApplicabilityId"
                                    [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                    [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && SeparationRuleDetail.DefaultRegularization">
                                {{Applicability.ApplicabilityName}}

                                <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                    class="bi bi-funnel"></i>
                            </label>
                            }
                        </div>
                    </div>
                    <div class="col-md-10">
                        <div class="row">
                            <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                    (change)="ApplicabilityCheckAll($event)">
                                <label for="SelectAll">
                                    Select All
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <label
                                *ngIf="ApplicabilityDatas.length == 0 && SeparationRuleDetail.WebESSApplicabilityId > 0">Please
                                select filter</label>
                            @for (ApplicabilityData of OrderByApplicability(); track
                            ApplicabilityData.ApplicabilityDataID;
                            let i = $index) {
                            <div class="col-md-4">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox"
                                        id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                        name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                        [(ngModel)]="ApplicabilityData.IsCheck">
                                    <label class="form-check-label applicability-font"
                                        for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                        {{ApplicabilityData.ApplicabilityData}}
                                    </label>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button (click)="close()" type="button" class="btn btn-outline-secondary mx-1">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary mx-1">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>